import { requestWithToken } from '../../utilities/request';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import AuthProvider, { needTokenUpdate } from '../../utilities/authProvider';

const fieldPath = '/api/private/fields';

/**
 * 作業員設定一覧取得API
 * @param {number} fieldId 現場ID
 * @param {object}param
 * */
const fetchWorkerSettingList = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: fieldPath.concat(`/${fieldId}/worker_settings/list`),
    params: param,
  });
};

/**
 * 作業員設定状態一覧取得API
 * @param {number} fieldId 現場ID
 * @param {object}param
 * */
const fetchWorkerSettingStatusList = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: fieldPath.concat(`/${fieldId}/worker_settings/status_list`),
    params: param,
  });
};

/**
 * ラピーダ連携API
 * @param {number} fieldId 現場ID
 * */
const registerFaceImages = fieldId => {
  return requestWithToken({
    method: 'POST',
    url: '/api/private/ccus/fields/face_image_register',
    data: { field_id: fieldId },
  });
};

/**
 * @param {string}fieldId: 現場ID
 * */
const fetchMainJvSecededCcus = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: fieldPath.concat(`/${fieldId}/main_jv_ccus_seceded_warning`),
  });
};

/**
 * 作業員設定データCSV取得API
 * @param {number} fieldId 現場ID
 * @param {object} param パラメーター
 * */
const fetchWorkerSettingListCSV = async (fieldId, param) => {
  let token = SessionStorageService.getToken();
  if (needTokenUpdate(token)) {
    token = await AuthProvider.instance.silentTokenUdate();
  }
  param.csv_token = token;
  return requestWithToken({
    method: 'GET',
    url: fieldPath.concat(`/${fieldId}/worker_settings/status_list_with_ccus_info.csv`),
    params: param,
    responseEncoding: 'shift-jis',
    responseType: 'blob',
  });
};

/**
 * 連携サービス関連のAPI群
 * */
export const WorkerSettingsApi = {
  fetchWorkerSettingList,
  fetchWorkerSettingStatusList,
  registerFaceImages,
  fetchMainJvSecededCcus,
  fetchWorkerSettingListCSV,
};

export default WorkerSettingsApi;



// WEBPACK FOOTER //
// ./src/services/workerSettings/WorkerSettingsApi.js